import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Resolve,Router, RouterStateSnapshot, RouterLink } from '@angular/router';
import { FormSessionCanDeactivate, PatientService, UserService } from '../shared';
import { environment } from '../shared/config/app-config';
import { Subscription } from 'rxjs/Subscription';
import { JwtService,User } from '../shared';
@Component({
  templateUrl: 'ipcapture.component.html',
  styleUrls: ['./style.component.css']

})

export class IpcaptureComponent extends FormSessionCanDeactivate {
  public data: Object;
  imagelogo
  apiurl = environment.api_url;
  params:any;
  currentUser:User;
  patimage:any={};
  pattimage:any={};
  subscription:Subscription;
  public imageURL:string;
  constructor( 
    private router:  ActivatedRoute,
    private patientservice: PatientService,
    private userService: UserService,
    private jwtService: JwtService
  ) {
    super();
  }
  ngOnInit() {  
    this.subscription = this.patientservice.navItem$
    .subscribe(item =>{
      
    }
    )
    this.router.params.subscribe( params => {
      this.params =params
     
    
    } );
    //////console.log(this.route.snapshot.url[0].path);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        
      }
    )
    if(this.currentUser.item.hostModel=="CLOUD")
    this.imageURL = environment.cloudeImageURL;
  else   
    this.imageURL = environment.vmImageURL;

    this.userService
    .getip()
    .subscribe(
      data => {
        // ////console.log(data);
       // this.jwtService.ipclientlogo(data.clientLogo);
        this.pattimage = data.ClientLogo
        // ////console.log(this.pattimage)
      }
    );

  }

  gwtImage(id){
    this.userService
    .getip()
    .subscribe(
      data => {
        //////console.log(this.params);
        this.jwtService.ipclientlogo(data.ClientLogo);
      // this.jwtService.saveclientlogo(data.clientLogo);
        this.patimage = window.localStorage['logopath']
        //////console.log(this.patimage)
      }
    );
  }

  
  
   
} 
  

   
 
  

